import { Get } from "domain/infra/data/api";
import { SistemaResponse } from "domain/types/sistema/sistemaResponse";
import DomainConstants from "../../infra/data/domainConstants";


export class SistemaService {// extends ExemploService {
  constructor() {
    //super()
  }

  async GetSistema(sistemaID: string): Promise<SistemaResponse | Error> {
    return await Get(`${DomainConstants.apiDomain.sistema.getSistema}?SistemaID=${sistemaID}`)
  }

  async GetSistemas(usuarioID: number): Promise<SistemaResponse[] | Error> {
    return await Get(`${DomainConstants.apiDomain.sistema.getSistemas}?usuarioID=${usuarioID}`)
  }
}
